require("!!/Users/edson/projetos_react/anteros-react/node_modules/script-loader/addScript.js")(require("!!/Users/edson/projetos_react/anteros-react/node_modules/raw-loader/index.js!/Users/edson/projetos_react/anteros-react/node_modules/bootstrap-switch/dist/js/bootstrap-switch.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap-switch/dist/js/bootstrap-switch.js
// module id = 1470
// module chunks = 0